<template>
  <v-form ref="form" v-bind="this.$attrs" class="mb-6">
    <v-row>
      <v-col cols="12" sm="6" md="12">
        <v-text-field
          v-model="driver"
          label="Tên tài xế"
          outlined
          required
          dense
          hide-details
          class="required font-size"
          :rules="[$rules.required]"
        />
      </v-col>
      <v-col cols="12" sm="6" md="12">
        <v-text-field
          v-model="cccd"
          label="CCCD"
          outlined
          required
          dense
          hide-details
          class="required font-size"
          :rules="[$rules.required]"
        />
      </v-col>
      <v-col cols="12" sm="6" md="12">
        <v-autocomplete
          v-model="driverLicense"
          :items="trueFalseData"
          @change="
            data => {
              valueChange('driverLicense', data)
            }
          "
          label="Giấy phép lái xe"
          item-text="text"
          item-value="value"
          clearable
          clear-icon="mdi-close"
          dense
          outlined
          return-object
          hide-details
        />
      </v-col>
      <v-col cols="12" sm="6" md="12">
        <v-autocomplete
          v-model="resume"
          :items="trueFalseData"
          @change="
            data => {
              valueChange('resume', data)
            }
          "
          label="Sơ yếu lý lịch"
          item-text="text"
          item-value="value"
          clearable
          clear-icon="mdi-close"
          dense
          outlined
          return-object
          hide-details
        />
      </v-col>
      <v-col cols="12" sm="6" md="12">
        <v-autocomplete
          v-model="healthCertificate"
          :items="trueFalseData"
          @change="
            data => {
              valueChange('healthCertificate', data)
            }
          "
          label="Giấy khám sức khỏe"
          item-text="text"
          item-value="value"
          clearable
          clear-icon="mdi-close"
          dense
          outlined
          return-object
          hide-details
        />
      </v-col>
      <v-col cols="12" sm="6" md="12">
        <v-text-field
          v-model="certificateTransportDriver"
          label="Giấy chứng nhận tập huấn nghiệp vụ lái xe kinh doanh vận tải"
          outlined
          required
          dense
          hide-details
          class="required font-size"
          :rules="[$rules.required]"
        />
      </v-col>
      <v-col cols="12" sm="6" md="12">
        <v-text-field
          v-model="insuranceCertificate"
          label="Chứng nhận bảo hiểm bắt buộc"
          outlined
          required
          dense
          hide-details
          class="required font-size"
          :rules="[$rules.required]"
        />
      </v-col>
      <v-col cols="12" sm="6" md="12">
        <v-text-field
          v-model="certificateHousehold"
          label="Giấy chứng nhận hộ kinh doanh cá thể"
          outlined
          required
          dense
          hide-details
          class="required font-size"
          :rules="[$rules.required]"
        />
      </v-col>
      <v-col cols="12" sm="6" md="12">
        <v-text-field
          v-model="motorLicense"
          label="Giấy phép kinh doanh vận tải bằng ô tô"
          outlined
          required
          dense
          hide-details
          class="required font-size"
          :rules="[$rules.required]"
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  props: {
    oldData: {
      type: Object
    }
  },
  data() {
    return {
      driver: '',
      cccd: '',
      certificateTransportDriver: '',
      insuranceCertificate: '',
      certificateHousehold: '',
      motorLicense: '',
      resume: null,
      healthCertificate: null,
      driverLicense: null,
      trueFalseData: [
        {
          text: 'Đủ',
          value: true
        },
        {
          text: 'Chưa có',
          value: false
        }
      ]
    }
  },
  methods: {
    getData() {
      if (this.$refs.form.validate()) {
        return {
          driver: this.driver,
          cccd: this.cccd,
          resume: this.resume,
          healthCertificate: this.healthCertificate,
          driverLicense: this.driverLicense,
          certificateTransportDriver: this.certificateTransportDriver,
          insuranceCertificate: this.insuranceCertificate,
          certificateHousehold: this.certificateHousehold,
          motorLicense: this.motorLicense
        }
      }
    },
    valueChange(attribute, data) {
      this[attribute] = data.value
    }
  },
  watch: {
    oldData: {
      handler(value) {
        if (value) {
          this.driver = this.oldData.driver
          this.cccd = this.oldData.cccd
          this.resume = value.resume
          this.healthCertificate = value.healthCertificate
          this.driverLicense = value.driverLicense
          this.certificateTransportDriver = value.certificateTransportDriver
          this.insuranceCertificate = value.insuranceCertificate
          this.certificateHousehold = value.certificateHousehold
          this.motorLicense = value.motorLicense
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style></style>
